import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

/**
 * NotFound component handles the rendering of a "Not Found" page when a user navigates to an invalid route.
 *
 * @returns {JSX.Element} The NotFound component with error message and embedded YouTube video for additional information.
 */
function NotFound() {
  return (
    <Grid
      container
      spacing={2}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", m: 5 }}>
        <Typography variant="h4">Oops, something went wrong!</Typography>
        <Typography variant="h5">Watch this video for more information!</Typography>
      </Box>

      <iframe
        width="500"
        height="500"
        src="https://www.youtube.com/embed/D8-xQLQjsh0?autoplay=1&mute=1"
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </Grid>
  );
}

export default NotFound;
